import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import "./Design/Dashboard.css"
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
const Pannel = () => {
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const renderNavLink = (label, path) => (
        <Nav.Link
            style={{ color: 'white', marginRight: '20px', paddingLeft: "10px" }}
            onClick={() => { navigate(path); setExpanded(false) }}
        >
            {label}
        </Nav.Link>
    );
    const logoutUser = () => {
        localStorage.clear();
        window.location.href = "/";
    }
    const [packageId, setPackageId] = useState(0);
    const [isAdmin, setIsAdmin] = useState(false);
    const [growniverseId, setGrowniverseId] = useState("");
    const hasRun = useRef(false);
    const [affiliateApproved, setAffiliateApproved] = useState(false);
    useEffect(() => {
        if (!hasRun.current) {
            const appKey = localStorage.getItem("appkey");
            if (appKey === null) {
                window.location.href = "/";
            }
            else {
                const storedProfile = localStorage.getItem("userProfile");
                const userProfile = JSON.parse(storedProfile ?? "");
                setIsAdmin(userProfile.isAdmin)
                setPackageId(userProfile.packageId);
                setGrowniverseId(userProfile.growniverseId);
                setAffiliateApproved(userProfile.affiliateApproved);
            }
            hasRun.current = true;
        }
    }, [hasRun])
    return <>
        <section className='' style={{ background: "black" }}>
            <Navbar expand="lg" expanded={expanded}>
                <Container>
                    <button
                        className="navbar-toggler"
                        style={{ border: "2px solid white" }}
                        type="button"
                        aria-controls="basic-navbar-nav"
                        onClick={() => { setExpanded(!expanded) }}
                    >
                        <i className="fas fa-align-left" style={{ color: "white" }}></i>
                    </button>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="me-auto growniverseBackground">
                            {!isAdmin && packageId > 0 && (
                                <>
                                    {affiliateApproved && <>
                                        {renderNavLink('Dashboard', '/dashboard')}
                                        {renderNavLink('Payouts', '/payouts')}
                                        {renderNavLink('My Kyc', '/kyc')}
                                        {renderNavLink('Training', '/training')}
                                        {renderNavLink('Wallet', '/mywallet')}
                                        {renderNavLink('Certification', '/certification')}
                                    </>}
                                    {renderNavLink('My Courses', '/mycourses')}
                                    {renderNavLink('Profile', '/profile')}
                                    {renderNavLink('Support', '/support')} 
                                </>
                            )}

                            {isAdmin && (
                                <>
                                    {renderNavLink('Package', '/packagepayment')}
                                    {renderNavLink('Turnover', '/admin')}
                                    {renderNavLink('Kyc', '/kycdetail')}
                                    {renderNavLink('WithDraw', '/withdrawrequests')}
                                    {renderNavLink('Users', '/userdetail')}
                                    {renderNavLink('Update User', '/updateuser')}
                                    {renderNavLink('Courses', '/admincourses')}
                                    {renderNavLink('Wallet', '/adminwallet')}
                                    {renderNavLink('Team', '/qualityUser')}
                                    {renderNavLink('MCQ', '/courseQuestion')}
                                    {renderNavLink('Coupon', '/couponCode')}
                                    {renderNavLink('Event', '/eventandpayment')}
                                    {renderNavLink('Customized', '/customized')}
                                    {renderNavLink('Notification', '/notification')}
                                </>
                            )}
                            <Button onClick={(logoutUser)} style={{ border: "1px solid #B7DAEE", color: "#B7DAEE" }}>
                                <b>Logout</b>
                            </Button>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </section>
    </>
};

export default Pannel;